var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLogoHo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.253,
    height: 50,
    viewBox: "0 0 129.253 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 282"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 157",
    d: "M414.862 56.586h4.6v-14.9h-4.6v5.593h-5.036v-5.594h-4.6v14.9h4.6v-5.592h5.036z",
    transform: "translate(-346.045 -35.575)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 158",
    d: "M519.53 59.17v.856a4.35 4.35 0 0 0-3.128-1.212c-3.142 0-5.513 3-5.513 6.364 0 3.628 2.152 6.364 5.394 6.364a4.222 4.222 0 0 0 3.247-1.212v.87h4.379V59.17zm-.076 6.008a2.4 2.4 0 0 1-2.164 2.586 2.628 2.628 0 0 1-.031-5.171 2.392 2.392 0 0 1 2.2 2.586",
    transform: "translate(-436.276 -50.232)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 159",
    d: "M610.641 59.17v15.217h4.379V70.33a4.378 4.378 0 0 0 3.3 1.212c2.833 0 5.343-2.736 5.343-6.364 0-3.36-2.32-6.364-5.462-6.364a4.514 4.514 0 0 0-3.178 1.212v-.856zm6.65 3.423a2.628 2.628 0 0 1-.031 5.171 2.623 2.623 0 0 1 .031-5.171",
    transform: "translate(-521.46 -50.235)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 160",
    d: "M706.75 59.17v15.217h4.379V70.33a4.378 4.378 0 0 0 3.3 1.212c2.833 0 5.343-2.736 5.343-6.364 0-3.36-2.32-6.364-5.462-6.364a4.514 4.514 0 0 0-3.178 1.212v-.856zm6.65 3.423a2.628 2.628 0 0 1-.031 5.171 2.623 2.623 0 0 1 .031-5.171",
    transform: "translate(-603.58 -50.235)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 161",
    d: "m800.423 61.293-2.28 5.616-2.276-5.616H791.3l4.643 11.2-1.919 4.634h4.5l6.462-15.83z",
    transform: "translate(-675.736 -52.352)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 162",
    d: "M412.075 202.766a7.956 7.956 0 1 1-7.955-7.821 7.8 7.8 0 0 1 7.955 7.821m-4.312 0a3.644 3.644 0 1 0-3.643 3.757 3.634 3.634 0 0 0 3.643-3.757",
    transform: "translate(-338.313 -166.535)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 163",
    d: "M590.709 197.558v3.719a4.569 4.569 0 0 0-3.2-1.212c-3.168 0-5.508 3-5.508 6.364 0 3.628 2.531 6.364 5.388 6.364a4.432 4.432 0 0 0 3.325-1.212v.866h4.415v-14.889zm-.077 8.87a2.411 2.411 0 0 1-2.182 2.586 2.624 2.624 0 0 1-.031-5.171 2.4 2.4 0 0 1 2.213 2.586",
    transform: "translate(-497 -168.765)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 164",
    d: "M522.39 215.826c-2.852-.851-4.262.714-4.771 2.2v-2.239h-4.41v12.033h4.41v-4.85c0-2.091 1.885-3.563 4.771-2.576 0-.528.01-4.284 0-4.568",
    transform: "translate(-438.249 -184.149)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 165",
    d: "M788.223 215.883c-2.852-.851-4.262.714-4.771 2.2v-2.239h-4.41v12.029h4.41v-4.85c0-2.091 1.885-3.563 4.771-2.576 0-.528.01-4.284 0-4.568",
    transform: "translate(-665.276 -184.198)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 166",
    d: "M686.69 224.009a2.657 2.657 0 0 1-2.574-1.988h9.128a6.122 6.122 0 0 0 .074-.8v-.148a6.5 6.5 0 0 0-6.615-6.35c-.2 0-.394.01-.588.025a6.469 6.469 0 0 0-6.06 6.325v.172a6.471 6.471 0 0 0 5.945 6.15h.017l.084.006c.2.016.4.026.608.026a6.6 6.6 0 0 0 6.326-4.506h-4.208a2.608 2.608 0 0 1-2.135 1.086m0-5.841a2.688 2.688 0 0 1 2.293 1.321H684.4a2.688 2.688 0 0 1 2.293-1.321",
    transform: "translate(-580.801 -183.41)",
    style: {
      fill: "#00a61c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 167",
    d: "M41.916 38.49H31.467a1.967 1.967 0 0 1-.355-.033 2.011 2.011 0 0 1-1.559-1.957v-5.148a1.813 1.813 0 0 0-1.5-1.783 1.858 1.858 0 0 0-.418-.05H16.817A1.815 1.815 0 0 0 15 31.33v5.15a2.014 2.014 0 0 1-2.017 2.011H2.638a2.382 2.382 0 0 0-2.386 2.377V47.6a2.382 2.382 0 0 0 2.386 2.38H15.42V50h26.5a2.382 2.382 0 0 0 2.38-2.377v-6.755a2.382 2.382 0 0 0-2.386-2.378m2.608-24.943c.019-.343.03-.689.03-1.045a15.275 15.275 0 0 0-1.338-6.549 10.148 10.148 0 0 0-3.791-4.405A10.323 10.323 0 0 0 33.8 0H10.755a10.326 10.326 0 0 0-5.626 1.548 10.154 10.154 0 0 0-3.791 4.406A15.273 15.273 0 0 0 0 12.5a15.27 15.27 0 0 0 1.338 6.549 10.144 10.144 0 0 0 3.791 4.405 10.312 10.312 0 0 0 5.625 1.548H33.8c.133 0 .263 0 .393-.006a10.611 10.611 0 0 0 3.628-.726 9.678 9.678 0 0 0 1.604-.816 9.74 9.74 0 0 0 1.233-.926 10.5 10.5 0 0 0 2.559-3.48 13.875 13.875 0 0 0 1.1-3.606c.029-.174.057-.351.08-.529.06-.446.1-.9.129-1.37zM14.44 15.35a2.68 2.68 0 0 1-1.378-.35 2.372 2.372 0 0 1-.929-1 3.557 3.557 0 0 1 0-2.982 2.369 2.369 0 0 1 .929-1 2.671 2.671 0 0 1 1.378-.352h15.667a2.657 2.657 0 0 1 1.324.352 2.369 2.369 0 0 1 .929 1 3.272 3.272 0 0 1 .328 1.491A3.271 3.271 0 0 1 32.36 14a2.357 2.357 0 0 1-.929 1 2.671 2.671 0 0 1-1.378.352H14.44z",
    transform: "translate(0 -.001)",
    style: {
      fillRule: "evenodd",
      fill: "#00a61c"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoHo);
export default __webpack_public_path__ + "static/media/ic-logo-ho.3c476b1f2ee5c27dd02078245fcd1023.svg";
export { ForwardRef as ReactComponent };